import { widget, resize } from "./src/widget";

window.addEventListener("click", resize, { capture: true });
widget();
